export const URL = 'https://wheel-wizard.onrender.com';
export const DB = 'POSTGRESQL';
